import dayjs from 'dayjs'
import { defaultBgImgId } from 'src/consumer/constants'
import { getCategoryListMap } from 'src/consumer/helpers/courseCardHelper'
import { getSessionId } from 'src/consumer/services/localstorageServices'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export function getDataForPlanDayItem(planEventData, setupData) {
  return planEventData?.plannedActivity
}

export const getPlanDurationText = (numberOfDays) => {
  if (numberOfDays % 7 === 0) {
    // if divisible by 7, so we can say weeks
    if (numberOfDays / 7 === 1) {
      return `${numberOfDays / 7} week`
    } else {
      return `${numberOfDays / 7} weeks`
    }
  } else {
    // if not divisible by 7, so we can say days
    if (numberOfDays === 1) {
      return `${numberOfDays} day`
    } else {
      return `${numberOfDays} days`
    }
  }
}

export function getPhaseCompletionData(phaseItem, userActivityItem) {
  const firstDay = phaseItem?.firstDay
  const lastDay = phaseItem?.lastDay
  const completedDays = userActivityItem?.lastCompletedDay
  if (completedDays > lastDay) {
    return {
      phaseProgress: 100,
    }
  } else {
    if (completedDays < firstDay) {
      return {
        phaseProgress: 0,
      }
    } else {
      const phaseProgress = Math.round(
        ((completedDays - firstDay + 1) / (lastDay - firstDay + 1)) * 100,
      )
      return {
        phaseProgress,
      }
    }
  }
}

export function checkIfSelectedPhaseIsTheLastPhase(selectedPhaseId, allPhases) {
  const lastPhase = allPhases?.[allPhases?.length - 1]
  if (selectedPhaseId === lastPhase?.id) {
    return true
  } else {
    return false
  }
}

export function checkIfSelectedPhaseIsTheFirstPhase(selectedPhaseId, allPhases, phasesAreValid) {
  if (!allPhases) {
    return true
  }
  const firstPhase = allPhases?.[0]
  if (selectedPhaseId === firstPhase?.id) {
    return true
  } else {
    return false
  }
}

export function getTheNextPhase(selectedPhaseId, allPhases) {
  const lastPhase = allPhases?.[allPhases?.length - 1]
  if (selectedPhaseId === lastPhase?.id) {
    return true
  } else {
    return false
  }
}

export const APItemDataExtractor = (item, setupData) => {
  let itemData = {}
  itemData.itemType = item?.type
  itemData.dfid = item?.dfid
  itemData.completed = item?.completed || false
  itemData.iconId = item?.coloredIconId || item?.iconId || ''
  itemData.coins = item?.coins || 0
  itemData.participantPics = item?.participantPics || []
  itemData.participants = item?.participants || ''
  itemData.altText = item?.altText || ''
  let categoryList = getCategoryListMap(setupData)

  if (item?.type === 'course') {
    itemData.imgId =
      item?.onlineCourse?.episode?.coverIcon || item?.onlineCourse?.episode?.coverImage || ''
    itemData.imgHasText = item?.onlineCourse?.episode?.coverIconHasText || false
    itemData.durationDetail = item?.onlineCourse?.episode?.duration
    itemData.cardData = {
      course: {
        id: item?.onlineCourse?.course?.id || '',
        title: item?.onlineCourse?.episode?.title || '',
        longDesc: item?.onlineCourse?.episode?.longDesc,
        courseType: item?.onlineCourse?.episode?.sessionType,
        categoryId: [item?.onlineCourse?.episode?.category?.[0]],
        altTextObject: categoryList
          ? categoryList?.get(item?.onlineCourse?.episode?.category[0])?.dailyPlayAltText
          : {},
        courseCategory: categoryList
          ? categoryList?.get(item?.onlineCourse?.episode?.category[0])?.singleTitle ||
            categoryList?.get(item?.onlineCourse?.episode?.category[0])?.name
          : '',
        sessions: [
          {
            ...item?.onlineCourse?.episode,
          },
        ],
      },
      teacher: {
        firstName: item?.onlineCourse?.teachers?.[0]?.firstName || '',
        profilePicId: item?.onlineCourse?.teachers?.[0]?.profilePicId || '',
      },
    }
  }
  if (item?.type === 'quote') {
    itemData.id = item?.quote?.id || ''
    itemData.imgId = item?.quote?.imageId || ''
    itemData.author = item?.quote?.author || ''
    itemData.category = item?.quote?.category || ''
    itemData.msg = item?.quote?.msg || ''
    itemData.durationDetail = '2 mins'
    itemData.customJournalId = item?.quote?.customJournalId || ''
    itemData.enableJournal = item?.quote?.enableJournal || false
    itemData.journalId = item?.quote?.journalId || ''
    itemData.altTextObject = categoryList ? categoryList?.get('myQuotes')?.dailyPlayAltText : {}
    itemData.category = categoryList
      ? categoryList?.get('myQuotes')?.singleTitle || categoryList?.get('myQuotes')?.name
      : ''
  }
  if (item?.type === 'journal') {
    itemData.journalData = item?.journal || ''
    itemData.title = item?.journal?.title || ''
    itemData.durationDetail = item?.journal?.journalQusAns?.length
    itemData.imgId = item?.journal?.coverIcon || item?.journal?.coverImage || defaultBgImgId
    itemData.altTextObject = categoryList ? categoryList?.get('myJournal')?.dailyPlayAltText : {}
    itemData.category = categoryList
      ? categoryList?.get('myJournal')?.singleTitle || categoryList?.get('myJournal')?.name
      : ''
  }
  if (item?.type === 'breathe') {
    itemData.imgId = item?.breathe?.coverIcon || item?.breathe?.coverImage || ''
    itemData.altTextObject = categoryList ? categoryList?.get('myBreathe')?.dailyPlayAltText : {}
    itemData.category = categoryList
      ? categoryList?.get('myBreathe')?.singleTitle || categoryList?.get('myBreathe')?.name
      : ''
    itemData.title = item?.breathe?.name || ''
    itemData.durationDetail = item?.breathe?.cycles
  }
  if (item?.type === 'practice') {
    itemData.imgId = item?.meditation?.coverIcon || item?.meditation?.coverImage || ''
    itemData.altTextObject = categoryList ? categoryList?.get('myPractices')?.dailyPlayAltText : {}
    itemData.category = categoryList
      ? categoryList?.get('myPractices')?.singleTitle || categoryList?.get('myPractices')?.name
      : ''
    itemData.title = item?.meditation?.title || ''
    if (item?.meditation?.durationType === 'fixed') {
      itemData.durationDetail = item?.meditation?.duration
    } else if (item?.meditation?.durationType === 'range') {
      itemData.durationDetail = [item?.meditation?.minDuration, item?.meditation?.maxDuration]
    } else {
      itemData.durationDetail = '∞'
    }
  }
  if (item?.type === 'mental-state-type') {
    itemData.itemId = item?.mentalStateType?.id
    itemData.question = item?.mentalStateType?.question
    itemData.title = item?.mentalStateType?.title
    itemData.qaTexts = item?.mentalStateType?.dailyPlayAltText
    itemData.options = item?.mentalStateType?.options
    itemData.completedValue = item?.completedValue
  }
  if (item?.type === 'assessment') {
    itemData.assessmentData = item?.assessment || ''
    itemData.title = item?.assessment?.title || ''
    itemData.durationDetail = item?.assessment?.journalQusAns?.length
    itemData.imgId = item?.assessment?.coverIcon || item?.assessment?.coverImage || defaultBgImgId
    itemData.altTextObject = categoryList ? categoryList?.get('assessment')?.dailyPlayAltText : {}
    itemData.category = categoryList
      ? categoryList?.get('assessment')?.singleTitle || categoryList?.get('assessment')?.name
      : ''
  }
  if (item?.type === 'article') {
    itemData.imgId = item?.article?.coverIcon || item?.article?.coverImage || ''
    itemData.title = item?.assessment?.title || ''
    itemData.altTextObject = categoryList ? categoryList?.get('article')?.dailyPlayAltText : {}
    itemData.category = categoryList
      ? categoryList?.get('article')?.singleTitle || categoryList?.get('article')?.name
      : ''
    itemData.articleData = item?.article
  }
  return itemData
}

export function checkIfActivityIsActive(
  selectedPhase,
  planItemIndex,
  userActivity,
  userActivityLogs,
  plannedActivity,
) {
  const today = dayjs()
  return today.isSame(dayjs(plannedActivity.estimatedCompletionDate), 'day')
}

export function checkIfPlannedActivityIsLocked(
  selectedPhase,
  planItemIndex,
  userActivity,
  userActivityLogs,
  plannedActivity,
) {
  const today = dayjs()
  return today.isBefore(dayjs(plannedActivity?.estimatedCompletionDate || today), 'day')
}

export function checkIfPlannedActivityHasPassed(
  selectedPhase,
  planItemIndex,
  userActivity,
  userActivityLogs,
  plannedActivity,
) {
  const today = dayjs()
  return today.isAfter(dayjs(plannedActivity.estimatedCompletionDate), 'day')
}

export function getLastCompletedDayWithTime(userActivityLogs, userActivity) {
  const sortedUserActivityLogs = userActivityLogs
  return sortedUserActivityLogs?.[0]
    ? {
        lastCompletedDay: sortedUserActivityLogs?.[0]?.plannedDay,
        attemptedTime: sortedUserActivityLogs?.[0]?.attemptedTime,
      }
    : { lastCompletedDay: userActivity?.lastCompletedDay, attemptedTime: dayjs() }
}

export function sortByLatestFirstUAPLogs(userActivityLogs) {
  return [userActivityLogs?.sort((a, b) => new Date(b?.attemptedTime) - new Date(a?.attemptedTime))]
}

export function checkIfCurrentPlannedItemIsCompleted(plannedItem, userActivityLogs) {
  const foundLog = userActivityLogs?.find((log) => log?.plannedActivityId === plannedItem?.id)
  return !!foundLog
}

export function getLogWithTheHighestPlannedDay(userActivityLogs = []) {
  const highestPlannedDayLog = userActivityLogs.reduce((prevLog, currentLog) => {
    return currentLog.plannedDay > prevLog?.plannedDay ? currentLog : prevLog
  }, {})
  return highestPlannedDayLog
}

export function getUniqueUserActivityProgressLogs(userActivityLogs = []) {
  const uniqueLogs = []
  const logMap = new Map()

  for (const log of userActivityLogs) {
    const { plannedActivityId, attemptedTime } = log
    if (
      !logMap.has(plannedActivityId) ||
      dayjs(logMap.get(plannedActivityId).attemptedTime).isBefore(attemptedTime)
    ) {
      logMap.set(plannedActivityId, log)
    }
  }

  for (const log of logMap.values()) {
    uniqueLogs.push(log)
  }

  return uniqueLogs
}

export function createActivityPlanWithEstimatedCompletionDates(activityPlan, UniqueUAPLogs = []) {
  const wasAnActivityCompletedToday = UniqueUAPLogs?.find((log) =>
    dayjs.utc(log?.attemptedTime).startOf('day').isSame(dayjs.utc().startOf('day'), 'day'),
  )

  console.log({ wasAnActivityCompletedToday })
  const today = dayjs()
  let undoneDays = 0
  const activityPlanToReturn = {
    ...activityPlan,
    plannedActivities: activityPlan?.plannedActivities?.map((pAct, pIndex) => {
      const foundLog = UniqueUAPLogs?.find((log) => log?.plannedActivityId === pAct?.id)
      let plannedActivityToReturn = {}
      if (foundLog) {
        plannedActivityToReturn = {
          ...pAct,
          estimatedCompletionDate: dayjs.utc(foundLog?.attemptedTime).local().startOf('day'),
        }
      } else {
        plannedActivityToReturn = {
          ...pAct,
          estimatedCompletionDate: dayjs(today)
            .startOf('day')
            .add(wasAnActivityCompletedToday ? undoneDays + 1 : undoneDays, 'days'),
        }
        undoneDays++
      }
      return plannedActivityToReturn
    }),
  }
  return activityPlanToReturn
}

export function getRestDaysPlannedItems(
  currentPlannedActivity,
  previousPlannedActivity,
  userActivity,
) {
  const currentPlannedDate = dayjs(currentPlannedActivity?.estimatedCompletionDate)
  const previousPlannedDate = previousPlannedActivity
    ? dayjs(previousPlannedActivity?.estimatedCompletionDate)
    : dayjs(userActivity?.createdTime).startOf('day')
  const restDays = currentPlannedDate.diff(previousPlannedDate, 'days') - 1
  const toReturn = Array.from({ length: restDays > 3 ? 3 : restDays }, (v, i) => {
    let _hideDate = false
    if (restDays >= 3) {
      const firstRestDay = 0
      const lastRestDay = 2
      if (i < lastRestDay && i > firstRestDay) {
        _hideDate = true
      }
    }
    return {
      ...previousPlannedActivity,
      plannedActivity: {
        ...previousPlannedActivity?.plannedActivity,
        activityTitle: _hideDate ? 'REST DAYS' : 'Took Rest',
        customCategoryTitle: _hideDate ? null : 'Hope you had a good rest!',
      },
      _hideDate,
      highlightTitle: _hideDate,
      estimatedCompletionDate: dayjs(previousPlannedDate).add(i + 1, 'days'),
    }
  })

  return toReturn
}

export function showPlanPhaseInTheList(
  currentPlannedActivity,
  currentPlannedActivityIndex,
  allPlanPhases,
) {
  const currentDay = currentPlannedActivityIndex + 1
  const currentPlanPhase = allPlanPhases?.find((phase) => phase?.firstDay === currentDay)
  return !!currentPlanPhase
}

export function planPhaseToShowInTheList(
  currentPlannedActivity,
  currentPlannedActivityIndex,
  allPlanPhases,
) {
  const currentDay = currentPlannedActivityIndex + 1
  const currentPlanPhase = allPlanPhases?.find((phase) => phase?.firstDay === currentDay)
  return currentPlanPhase
}

export function getPhasesWithStartedOrNotInformation(allPhases, userActivityProgressLogs, urlDay) {
  const latestUserActivityProgressLogsBasedOnPlannedDay =
    getLogWithTheHighestPlannedDay(userActivityProgressLogs)

  const toReturn = allPhases?.map((phase, idx) => {
    let doesUrlDayCollideWithThisPhase = false
    if (urlDay) {
      doesUrlDayCollideWithThisPhase = urlDay >= phase?.firstDay ? true : false
    }

    if (userActivityProgressLogs?.length === 0) {
      return {
        ...phase,
        started: (idx === 0 ? true : false) || doesUrlDayCollideWithThisPhase,
      }
    }
    const foundLog = userActivityProgressLogs?.find((log) => log?.plannedDay + 1 >= phase?.firstDay)
    return {
      ...phase,
      started: !!foundLog || doesUrlDayCollideWithThisPhase,
    }
  })
  return toReturn
}

export function showThisPlanItemBasedOnIfPhaseHasStartedOrNot(
  planItem,
  planItemIndex,
  allPhases,
  userActivityProgressLogs,
  isNotTablet,
  phasesAreValid,
) {
  if (!phasesAreValid) {
    return true
  }

  if (isNotTablet) {
    return true
  }
  const currentDay = planItemIndex + 1
  const currentPlanPhase = allPhases?.find(
    (phase) => phase?.firstDay <= currentDay && phase?.lastDay >= currentDay,
  )
  if (currentPlanPhase?.started) {
    return true
  }

  return false
}

export function getPhaseItemIfNone(activityPlan) {
  return {
    title: activityPlan?.title,
    description: activityPlan?.description,
    coverIcon: activityPlan?.coverImage,
    firstDay: 1,
    lastDay: activityPlan?.totalDays,
    id: 'my-app',
  }
}

export function getPlayerDataForActivity(course, teacher, sessionId, refreshFunction) {
  return {
    course: {
      ...course,
      sessions: [course?.sessions?.find((item) => item?.sessionId === sessionId)],
    },
    teacher: { ...teacher },
  }
}

export async function canUserAccessThisActivity(activityPlan, plannedActivity) {
  const currentSessionId = getSessionId()
  const resp = await getDataWithParams('/api/secure/v3/activity-plan/activity/signedUrl', {
    activityPlanId: activityPlan?.id,
    plannedActivityId: plannedActivity?.id,
    activityId: plannedActivity?.plannedActivity?.id,
    clientSessionId: currentSessionId,
  })
  if (resp?.status === 200 && isCommonResponseSuccessful(resp.data.code)) {
    return resp.data.data
  }
  return false
}
